import styled from '@emotion/styled'
import { CardAuthor, MediaQueries, theme } from '@hhgtech/hhg-components'

export const StyledWrapper = styled.div`
  flex: 1 1 0px;
  background: white;
  border: 1px solid ${theme.colors.neutral100};
  border-radius: 8px;
  padding: 16px 16px 60px;

  .post-author,
  .post-content-wrapper {
    padding-left: 0;
    padding-right: 0;
  }
  .post-content-wrapper {
    padding-bottom: 0;
  }

  ${MediaQueries.mbUp} {
    padding: 24px 24px 60px;
  }

  .cursor-pointer {
    cursor: pointer;
  }
`
export const StyledHeader = styled.div`
  margin-bottom: 12px;
`
export const StyledBody = styled.div`
  font-size: 14px;
`
export const StyledRow = styled.div`
  ${MediaQueries.mbUp} {
    display: flex;
    justify-content: space-between;
  }
`

export const StyledPostContentWrapper = styled.div``
export const StyledContent = styled.div`
  position: relative;
  &[data-has-thumb='true'] {
    ${MediaQueries.mbUp} {
      width: calc(100% - 140px);
    }
  }
`
export const StyledThumb = styled.div`
  margin-top: 12px;
  ${MediaQueries.mbUp} {
    margin-top: 0;
    width: 120px;
  }

  img {
    max-width: 100%;
  }
`
export const StyledCardAuthor = styled(CardAuthor)``
export const StyledTitle = styled.div`
  font-weight: 600;
`
export const StyledDesc = styled.div``
export const StyledAction = styled.div``
export const StyledOverlayLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
